export default "__VITE_ASSET__CdztgqP9__"